export default "__VITE_ASSET__DxypWqkN__"